import {Injectable} from '@angular/core';
import {BaseService} from "./base.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";
import {Observable} from "rxjs";
import {AppUrl} from "../constants/app-url";

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService,) {
    super(http, alertService, globalService);
  }

  send(data: {} = {}): Observable<any> {
    return this.postRequest(AppUrl.INVIGILATOR_NOTIFICATION(), data);
  }

  invigilatorNotifications(data: any): Observable<any> {
    return this.getRequest(AppUrl.INVIGILATOR_NOTIFICATIONS(), data);
  }

  markRead(): Observable<any> {
    return this.putRequest(AppUrl.MARK_READ());
  }

  list(data: any = {}): Observable<any> {
    return this.getRequest(AppUrl.GENERAL_NOTIFICATION_LIST(), data);
  }

}
